<template>
  <div
    class="cntb"
    style="--clr-primary: var(--clr-primary-brand)"
  >
    <CursorPulseCircle :elementBlacklistIds="['dashboard_learnMoreBtn']">
      <div
        class="cntb_inner"
        style="padding: 1rem clamp(1px, 4rem, 12vw); overflow: hidden"
      >
        <div
          class="cntb_inner_back"
          style="z-index: 1"
        ></div>
        <div
          class="f-column py-4 flex-wrap w-100"
          style="position: relative; z-index: 6; gap: 1rem"
        >
          <div class="f-row f-wrap font-poppins justify-space-between align-center w-100 ga-4">
            <div
              class="f-column"
              style="font-size: clamp(1px, 2.5rem, 8vw)"
            >
              <div
                class="f-column d-flex"
                :style="mobile && 'font-size: 2rem !important; text-align: center'"
              >
                <span class="clr-primary weight_600 text-nowrap">GTO Reports:</span>
                <span class="weight_600 text-nowrap">Your Personalized</span>
                <span class="weight_600 text-nowrap">Leak-Finding Machine</span>
              </div>
            </div>
            <div
              id="dashboard_learnMoreBtn"
              :class="mobile ? 'ma-auto' : 'ml-auto mt-auto'"
            >
              <button
                style="
                  --radius: 0.5rem;
                  color: var(--clr-black-0) !important;
                  font-weight: 700;
                  z-index: 99;
                "
                class="gw_btn gw_btn_primary cntb_message_btn weight_500 clr-white"
                :class="!mobile ? 'text-h6 py-6 px-8' : 'text-large mx-auto py-4 mt-2 w-100'"
                @click.stop="handleClick"
              >
                {{ $t('btn.try_it_now') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CursorPulseCircle>
  </div>
</template>

<script>
import CursorPulseCircle from '@/components/lib/CursorPulseCircle.vue'

export default {
  name: 'DashboardBannerRls',
  // mixins: [links_mix, tier_mix],
  components: {
    CursorPulseCircle,
  },
  data() {
    return {}
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/earlybird/${img}`, import.meta.url).href
    },
    handleClick() {
      // TODO: fix this
      // this.$router.push({
      //   name: 'GtoReports',
      // })
      window.open('/analyze/reports/')
    },
  },
  computed: {
    isDev() {
      return import.meta.env.VITE_ENV !== 'production'
    },
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
  },
}
</script>

<style lang="scss" scoped>
.svg-holder {
  z-index: 1;
  position: absolute;
  right: 2%;
  top: -124%;
  height: 33rem;
  svg {
    width: 100%;
    height: 100%;
  }
}

.cntb_tag {
  position: absolute;
  z-index: 1;
  top: 0.8rem;
  left: -3.2rem;
  font-size: 1rem;
  padding: 0.4rem 4rem;
  text-align: center;
  transform: rotate(-45deg);
  font-weight: 700;
}
.banner-link-text {
  color: var(--clr-white) !important;
  transition: all 0.3s ease;
}
.cntb {
  position: relative;
  background: #1d1d1d;
  width: 100%;
  flex-shrink: 0;
  border-radius: 8px;
  // overflow: hidden;
  &_inner {
    // overflow: hidden;
    border-radius: 8px;
    background: var(--clr-black-0);
    border: solid var(--clr-black-1) 1px;
    &::before {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 2;
      --opacity: 0.4;
      // --back-from: rgba(18, 18, 18, var(--opacity));
      // --back-from: rgba(0, 172, 141, 0.05);
      // --back-from: rgba(0, 172, 141, 1);
      --back-from: rgba(0, 0, 0, 0.75);
      // --back-from: rgba(0, 172, 141, 0.1);
      // --back-from: rgba(0, 0, 0, 1);
      // --back-from: rgba(0, 33, 47, 0.6);
      --back-to: transparent;
      overflow: hidden;

      border-radius: 8px;
      //background: linear-gradient(to left, var(--back-to), var(--back-from));
    }
    &_back {
      z-index: 0;
      position: absolute;
      height: 100%;
      width: 100%;
      // width: 100%;
      // top: 0;
      left: 0%;
      // left: 0;
      z-index: -1;
      // background: url('@/assets/img/drills_management_new_blockers_score_without_overlay.webp');
      // background: url('@/assets/img/app_banner_analyzer.webp');
      background: url('@/assets/img/app_banner_gtoreports.webp');
      // background: url('@/assets/img/app_banner_image_icm.webp');
      //background: url('@/assets/img/app_banner_image.webp');
      // background: url('@/assets/img/icmWinner.webp');
      // background: url('@/assets/img/app_bannerx2.webp');
      // background: url('@/assets/img/world_pro.webp');
      // background: url('@/assets/img/app_banner_new_interface.webp');
      // background: url('@/assets/img/fairplay.webp');
      // background: url('@/assets/img/rakebanner.webp');
      // background: url('@/assets/img/app_banner_wrapup2023.webp');
      // background: url('@/assets/img/app_banner_5.webp');
      background-repeat: no-repeat;
      background-size: cover;
      // overflow: hidden;
      border-radius: 8px;
    }
    position: relative;
    display: flex;
    min-height: 12.5rem;
    flex-shrink: 0;
    justify-content: center;
    z-index: 4;
  }
  &_img {
    width: 25%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      position: absolute;
      height: 13.5rem;
      bottom: -1.5rem;
    }
  }
  &_message {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 1.75rem;
    font-weight: 700;
    width: 37.5%;
    padding: 0 2rem 0 1rem;
    // padding: 0 1rem 0 1rem;
    line-height: 1.3;
    &_btn {
      min-width: 7.5rem;
    }
  }
}
@media (max-width: 1024px) {
  .cntb_inner_back {
    background-position-x: 50%;
  }
  .cntb_message_btn {
    width: 12rem !important;
    margin: 0 auto !important;
  }
}

@media (max-width: 768px) {
  .img-avatar-box {
    margin-left: -1.75rem;
  }
  .cntb_inner_back {
    &::before {
      background: linear-gradient(25deg, var(--back-from), var(--back-to) 444%);
    }
    background-size: cover;
    background-position-x: 0;
  }
}
@media (max-width: 500px) {
  .svg-holder {
    right: 2%;
    top: -50%;
    height: 33rem;
  }
  .cntb_inner_back {
    background-position-x: 50%;
    opacity: 0.5;
  }
}
</style>
